(function(){
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  function toast(msg){const el=$('#toast');if(!el)return;el.textContent=msg;el.classList.add('show');clearTimeout(window.__toast);window.__toast=setTimeout(()=>el.classList.remove('show'),2400)}
  async function cart(){return fetch('/cart.js').then(r=>r.json())}
  function money(cents){return 'Rs. '+(cents/100).toLocaleString('en-PK',{maximumFractionDigits:0})}
  function renderCart(c){
    const count=$('[data-cart-count]'); if(count){count.textContent=c.item_count;count.hidden=!c.item_count}
    const body=$('[data-cart-items]'), total=$('[data-cart-total]');
    if(!body)return;
    if(!c.items.length){body.innerHTML='<div class="empty">Your bag is empty.</div>'}else body.innerHTML=c.items.map(i=>`<div class="drawer-item"><img src="${i.image}" alt="${i.title.replace(/"/g,'&quot;')}"><div><h4>${i.product_title}</h4><p>${i.variant_title||''}</p><p>${money(i.final_line_price)}</p><div class="qty"><button data-change="${i.key}" data-qty="${i.quantity-1}">−</button><input value="${i.quantity}" readonly><button data-change="${i.key}" data-qty="${i.quantity+1}">+</button></div></div><button class="icon-btn" data-change="${i.key}" data-qty="0" aria-label="Remove">×</button></div>`).join('');
    if(total)total.textContent=money(c.total_price);
  }
  async function refresh(){const c=await cart();renderCart(c);return c}
  async function add(id,qty=1){const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:qty}]})});if(!r.ok){toast('Please select an available variant');return}await refresh();openDrawer();toast('Added to bag')}
//   async function add(formData){
//   const id = formData.get('id');
//   const qty = Number(formData.get('quantity') || 1);

//   const properties = {};

//   for (const [key, value] of formData.entries()) {
//     if (key.startsWith('properties[')) {
//       const propertyName = key.slice(11, -1);
//       properties[propertyName] = value;
//     }
//   }

//   const item = {
//     id: Number(id),
//     quantity: qty
//   };

//   if (Object.keys(properties).length) {
//     item.properties = properties;
//   }

//   const r = await fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     },
//     body: JSON.stringify({
//       items: [item]
//     })
//   });

//   if (!r.ok) {
//     const error = await r.json().catch(() => ({}));
//     console.error('ATC error:', error);
//     toast(error.description || 'Please select an available variant');
//     return;
//   }

//   await refresh();
//   openDrawer();
//   toast('Added to bag');
// }

  function openDrawer(){const d=$('[data-cart-drawer]');if(d){d.classList.add('open');document.body.style.overflow='hidden'}}
  function closeDrawer(){const d=$('[data-cart-drawer]');if(d){d.classList.remove('open');document.body.style.overflow=''}}
  document.addEventListener('click',async e=>{
    const addBtn=e.target.closest('[data-add-to-cart]'); 
    if(addBtn){e.preventDefault();const form=addBtn.closest('form');const fd=new FormData(form);const id=fd.get('id');const qty=Number(fd.get('quantity')||1);await add(id,qty);return}
//     if (addBtn) {
//   e.preventDefault();

//   const form = addBtn.closest('form');

//   if (!form) return;

//   const fd = new FormData(form);

//   addBtn.disabled = true;

//   try {
//     await add(fd);
//   } finally {
//     addBtn.disabled = false;
//   }

//   return;
// }

    if(e.target.closest('[data-open-cart]')){e.preventDefault();openDrawer();await refresh()}
    if(e.target.closest('[data-close-cart]')||e.target.matches('[data-cart-backdrop]')){closeDrawer()}
    const ch=e.target.closest('[data-change]'); if(ch){e.preventDefault();await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:ch.dataset.change,quantity:Number(ch.dataset.qty)})});await refresh()}
    const menu=e.target.closest('[data-menu-toggle]'); if(menu){document.body.classList.toggle('menu-open');$('[data-mobile-menu]')?.classList.toggle('open')}
    if(e.target.closest('[data-menu-close]')){document.body.classList.remove('menu-open');$('[data-mobile-menu]')?.classList.remove('open')}
    const search=e.target.closest('[data-search-toggle]'); if(search){e.preventDefault();$('[data-search-panel]')?.classList.toggle('open');$('[data-search-input]')?.focus()}
  });
  document.addEventListener('DOMContentLoaded',()=>{refresh(); $$('[data-reveal]').forEach(el=>{const io=new IntersectionObserver(es=>es.forEach(x=>{if(x.isIntersecting){x.target.classList.add('is-visible');io.unobserve(x.target)}}),{threshold:.08});io.observe(el)});});
})();
/* Product variant selectors */(function(){
  const form=document.querySelector('[data-product-options]')?.closest('form');
  if(!form)return;
  const data=form.querySelector('[data-product-variants]');
  if(!data)return;
  let variants=[];
  try{variants=JSON.parse(data.textContent)}catch(e){return}
  const groups = [...form.querySelectorAll('[data-option-index]')]
  .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));
  const variantInput=form.querySelector('[data-variant-id]');
  const addBtn=form.querySelector('[data-add-to-cart]');
  const optionValues=()=>groups.map(g=>g.querySelector('.is-selected')?.dataset.optionValue||'');
  function sync(){
    const selected=optionValues();
    const exact=variants.find(v=>v.options.every((value,i)=>value===selected[i]));
        const canBuy = Boolean(exact && exact.available);

    if (variantInput) {
      variantInput.value = exact ? exact.id : '';
      variantInput.disabled = !exact;
    }

    if (addBtn) {
      addBtn.disabled = !canBuy;
      addBtn.style.setProperty('display', 'flex', 'important');
      addBtn.textContent = canBuy
        ? 'Add to bag'
        : exact ? 'Sold out' : 'Unavailable';

      if (!canBuy) {
        addBtn.style.setProperty('background', '#e5e5e5', 'important');
        addBtn.style.setProperty('color', '#777', 'important');
        addBtn.style.setProperty('cursor', 'not-allowed');
      } else {
        addBtn.style.removeProperty('background');
        addBtn.style.removeProperty('color');
        addBtn.style.removeProperty('cursor');
      }
    }

    const buyNow = form.querySelector('.product-buy-now');

    if (buyNow) {
      buyNow.style.setProperty(
        'display',
        canBuy ? 'block' : 'none',
        'important'
      );

      let soldOutButton = form.querySelector('[data-sold-out-buy-now]');

      if (!soldOutButton) {
        soldOutButton = document.createElement('button');
        soldOutButton.type = 'button';
        soldOutButton.disabled = true;
        soldOutButton.dataset.soldOutBuyNow = '';
        soldOutButton.className = 'btn btn-dark';
        soldOutButton.style.cssText =
          'width:100%;margin-top:12px;background:#e5e5e5!important;' +
          'color:#777!important;cursor:not-allowed;';
        buyNow.after(soldOutButton);
      }

      soldOutButton.textContent = exact ? 'Sold out' : 'Unavailable';
      soldOutButton.style.setProperty(
        'display',
        canBuy ? 'none' : 'block',
        'important'
      );
    }
    groups.forEach((group,index)=>{
      const other=selected.slice();
      group.querySelectorAll('[data-option-value]').forEach(btn=>{
        const value=btn.dataset.optionValue;
        other[index]=value;
        const name = group.dataset.optionName.toLowerCase();
const isColor = name === 'color' || name === 'colour';

const possible = variants.some(v =>
  v.available &&
  v.options.every((x, i) => {
    if (isColor) {
      return !other[i] || x === other[i];
    }

    return i !== index || x === value;
  })
);
       btn.disabled = false;
btn.removeAttribute('aria-disabled');
btn.classList.toggle('is-unavailable', !possible);
      });
    });
  }
  groups.forEach(group=>{
    group.addEventListener('click',e=>{
      const button=e.target.closest('[data-option-value]');
      if(!button||button.disabled)return;
      group.querySelectorAll('[data-option-value]').forEach(b=>b.classList.remove('is-selected'));
      button.classList.add('is-selected');
      sync();
    });
  });
  const minus=form.querySelector('[data-qty-minus]'),plus=form.querySelector('[data-qty-plus]'),qty=form.querySelector('[data-product-quantity]');
  minus?.addEventListener('click',()=>{qty.value=Math.max(1,Number(qty.value||1)-1)});
  plus?.addEventListener('click',()=>{qty.value=Math.max(1,Number(qty.value||1)+1)});
  sync();
})();

/* Product gallery + size chart */
(function(){
  document.addEventListener('click', function(e){
    const thumb=e.target.closest('[data-gallery-thumb]');
    if(thumb){
      const gallery=thumb.closest('[data-product-gallery]');
      const main=gallery&&gallery.querySelector('[data-gallery-main]');
      if(main){ main.src=thumb.dataset.imageSrc; main.removeAttribute('srcset'); }
      gallery&&gallery.querySelectorAll('[data-gallery-thumb]').forEach(t=>t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      return;
    }
    const open=e.target.closest('[data-size-chart-open]');
    if(open){
      const modal=document.querySelector('[data-size-chart-modal]');
      if(modal){modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');document.body.classList.add('size-chart-open');}
      return;
    }
    const close=e.target.closest('[data-size-chart-close]');
    if(close){
      const modal=close.closest('[data-size-chart-modal]');
      if(modal){modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');document.body.classList.remove('size-chart-open');}
    }
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape') document.querySelectorAll('[data-size-chart-modal].is-open').forEach(m=>{m.classList.remove('is-open');m.setAttribute('aria-hidden','true');document.body.classList.remove('size-chart-open');});
  });
})();


/* Respect an existing product-description "Show more" control supplied by the store/product content. */
(function(){
  function setupExistingDescriptionToggle(){
  document.querySelectorAll('.product-description details').forEach(function(details){
    details.removeAttribute('open');

    const summary = details.querySelector('summary');
    if (
      summary &&
      /^(read more|show more)$/i.test(summary.textContent.trim())
    ) {
      summary.textContent = 'Show more';
    }
  });
    document.querySelectorAll('.product-description-section').forEach(function(section){
      const desc=section.querySelector('.product-description');
      if(!desc || desc.dataset.nativeToggleReady) return;
      const candidates=Array.from(section.querySelectorAll('button,a,[role="button"]'));
      const toggle=candidates.find(function(el){return (el.textContent||'').trim().toLowerCase()==='show more';});
      if(!toggle) return;
      desc.dataset.nativeToggleReady='true';
      if(desc.contains(toggle)){
        const wrap=document.createElement('div');
        wrap.className='description-collapsed-content';
        desc.insertBefore(wrap,toggle);
        while(wrap.nextSibling && wrap.nextSibling!==toggle){ wrap.appendChild(wrap.nextSibling); }
        toggle.addEventListener('click',function(){
          wrap.classList.add('is-description-expanded');
          toggle.setAttribute('aria-expanded','true');
        },{capture:true});
      }else{
        desc.classList.add('has-native-toggle');
        toggle.addEventListener('click',function(){
          desc.classList.add('is-description-expanded');
          toggle.setAttribute('aria-expanded','true');
        },{capture:true});
      }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setupExistingDescriptionToggle); else setupExistingDescriptionToggle();
})();